import React from 'react';
import { ModuleManifest } from '../../services/ModuleScanner';

interface Props {
  module: ModuleManifest;
  isCore: boolean;
  onToggle?: (id: string, enabled: boolean) => void;
}

export const ModuleCard: React.FC<Props> = ({ module, isCore, onToggle }) => (
  <div style={{
    background: 'var(--theme-bg-card, #151d2a)',
    border: '1px solid var(--theme-border, #1e293b)',
    borderRadius: '8px',
    padding: '14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div>
        <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--theme-text-primary, #f1f5f9)' }}>
          {module.title}
        </div>
        <div style={{ fontSize: '10px', fontFamily: 'monospace', color: 'var(--theme-text-muted, #94a3b8)' }}>
          {module.id}
        </div>
      </div>
      <span style={{ fontSize: '9px', background: 'rgba(56, 189, 248, 0.1)', color: 'var(--theme-accent, #38bdf8)', padding: '2px 6px', borderRadius: '4px' }}>
        {module.category}
      </span>
    </div>
    <div style={{ fontSize: '11px', color: 'var(--theme-text-secondary, #cbd5e1)' }}>
      {module.description}
    </div>
    {isCore ? (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '6px' }}>
        <span style={{ fontSize: '10px', color: '#94a3b8', fontFamily: 'monospace' }}>
          v{module.version || '1.0.0'} • Auto-Update: Enabled
        </span>
        <span style={{
          fontSize: '9px',
          fontWeight: 700,
          background: 'rgba(56, 189, 248, 0.15)',
          color: 'var(--theme-accent, #38bdf8)',
          border: '1px solid rgba(56, 189, 248, 0.3)',
          padding: '3px 8px',
          borderRadius: '4px'
        }}>
          🔒 SYSTEM CORE
        </span>
      </div>
    ) : onToggle ? (
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '6px' }}>
        <button
          onClick={() => onToggle(module.id, module.status !== 'enabled')}
          style={{
            padding: '4px 10px',
            borderRadius: '6px',
            border: 'none',
            background: module.status === 'enabled' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(255, 255, 255, 0.06)',
            color: module.status === 'enabled' ? '#34d399' : '#94a3b8',
            fontSize: '10px',
            fontWeight: 700,
            cursor: 'pointer'
          }}
        >
          {module.status === 'enabled' ? '⚡ ENABLED' : '○ DISABLED'}
        </button>
      </div>
    ) : null}
  </div>
);
